import { render, staticRenderFns } from "./paragraph.vue?vue&type=template&id=722c4ee9"
import script from "./paragraph.vue?vue&type=script&lang=ts"
export * from "./paragraph.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports